import Button from "./Button";
import { HiArrowRight } from "react-icons/hi";

const ProceedButton = () => {
  return (
    <Button padding={"p-[14px]"} width="w-full">
      <div className="flex justify-between w-full">
        <div className="total flex flex-col text-[13px]">
          Total
          <span className="text-base font-medium leading-3">$19</span>
        </div>
        <div className="proceed uppercase flex items-center text-[13px]">
          <span className="mr-2">Proceed</span>
          <span>
            <HiArrowRight />
          </span>
        </div>
      </div>
    </Button>
  );
};

export default ProceedButton;
